'use client';

export function particles(container, options = {}) {
  if (!container) return;

  // Clear previous particles
  container.innerHTML = '';

  const isMobile = window.innerWidth <= 768;
  
  const {
    particleCount = isMobile ? 10 : 20,
    minSize = 2,
    maxSize = 10,
    minOpacity = 0.8,
    maxOpacity = 1,
    minDelay = 0,
    maxDelay = 2,
    minDuration = 4,
    maxDuration = 8,
  } = options;

  const fragment = document.createDocumentFragment();

  for (let i = 0; i < particleCount; i++) {
    const particle = document.createElement('div');
    particle.classList.add('intro__performer');

    // Randomize size
    const size = Math.random() * (maxSize - minSize) + minSize;
    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;

    // Random position
    particle.style.left = `${Math.random() * 100}%`;
    particle.style.top = `${Math.random() * 100}%`;

    // Random animation delay and duration
    const delay = Math.random() * (maxDelay - minDelay) + minDelay;
    const duration = Math.random() * (maxDuration - minDuration) + minDuration;

    particle.style.animationDelay = `${delay}s`;
    particle.style.animationDuration = `${duration}s`;

    // Random opacity
    particle.style.opacity = Math.random() * (maxOpacity - minOpacity) + minOpacity;

    // Glow colors applied based on position
    const glow = i % 2 === 0 ? '--glow-1' : '--glow-4';
    particle.style.setProperty('box-shadow', `0 0 5px var(${glow}), 0 0 10px var(${glow}), 0 0 15px var(${glow}), 0 0 20px var(${glow})`);

    fragment.appendChild(particle);
  }

  // Append all at once to prevent reflow
  container.appendChild(fragment);
}
